<template>
  <div>
    <pagination-table
      title="تیکت پشتیبانی"
      :tableHeaders="[
        'شناسه',
        'نام مجموعه',
        'بخش',
        'موضوع',
        'وضعیت',
        'آخرین به روزرسانی',
      ]"
      :fetchData="getTickets"
      @onClickItem="onClickTicket"
    >
      <template #header-actions>
        <vs-button @click="createNewTicket">ایجاد تیکت</vs-button>
      </template>
      <template v-slot:default="props">
        <td>
          {{ props.item.id }}
        </td>
        <td>
          {{ currentProvider.persian_name }}
        </td>
        <td>
          {{ getDepartment(props.item.department) }}
        </td>
        <td>
          {{ props.item.title }}
        </td>
        <td>
          {{ getStatus(props.item.status) }}
        </td>
        <td>
          {{ getLastTimeUpdated(props.item.updated_at) }}
        </td>
      </template>
    </pagination-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import providerApiService from "../../../services/api/ProviderApiService";
import PaginationTable from "../../../components/pagination-table/PaginationTable.vue";
import {
  convertDateToHumanReadable,
  getDepartmentLabel,
  getTicketStatus,
} from "../../../helpers/Functions";

export default {
  name: "CouponsList.vue",
  components: { PaginationTable },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  methods: {
    async getTickets(page) {
      try {
        const result = await providerApiService.getProviderTickets(
          this.currentProvider.id,
          page
        );
        return result;
      } catch (e) {
        return e;
      }
    },
    createNewTicket() {
      this.$router.push(`/tickets/create`);
    },
    onClickTicket(ticket) {
      this.$router.push(`/tickets/${ticket.id}`);
    },
    ticketCreated(coupon) {
      this.$refs.unlimitedListRef.createItem(coupon);
    },
    getStatus(value) {
      return getTicketStatus(value);
    },
    getDepartment(value) {
      return getDepartmentLabel(value);
    },
    getLastTimeUpdated(value) {
      return convertDateToHumanReadable(value, true);
    },
  },
};
</script>
